import {MITTWALD_API, Schemas} from "../middleware/MittwaldApi";
import * as ActionTypes from "../constants/ActionTypes";
import {queryBearerToken} from "./UserAuthentication";

const fetchCustomerContracts = (bearer, customerNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.CONTRACTS_REQUEST, ActionTypes.CONTRACTS_SUCCESS, ActionTypes.CONTRACTS_FAILURE],
        endpoint: `customers/${customerNumber}/contracts`,
        schema: Schemas.CONTRACTS,
        bearer: bearer,
        method: 'GET',
        postData: {}
    }
})


export const queryCustomerContracts = (customerNumber) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchCustomerContracts(getState().token.bearer, customerNumber))
    })
}


/** WEBPACK FOOTER **
 ** ./src/actions/Contracts.js
 **/